import React, { useState, useEffect } from "react";
import "../../../../src/styles/organization.css";
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import * as Yup from "yup";
import displayToastMessage from "../../../../src/components/Common/Alert/displayToastMessage";
import OrganisationForm from "./OrganisationForm";
import PropTypes from 'prop-types'
import APIService from "../../../services/apiAxiosService.js";
import useHttp from "../../../hooks/useHttp.js";
import {Table, Column} from "@appkit4/react-components/table";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";

export default function Organization(props) {
  const formValues = {
    organizationName: "",
    parentOrganizationName: "",
    childOrganizationName: "",
    level: "",
  }
  const [visible, setVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [organizationName, setOrganizationName] = useState("");
  const [parentOrganizationName, setParentOrganizationName] = useState("");
  const [childOrganizationName, setChildOrganizationName] = useState("");
  const [level, setLevel] = useState(null);
  const [loading, setLoading] = useState(false);
  const [orgDetails,setOrgDetails]=useState()
  const [addOrgLoader, setAddOrgLoader] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [indicator, setIndicator] = useState(false);
  const [initialValues, setInitialValues]=useState(formValues);
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const { sendRequest: addNewOrganization } = useHttp();
  const { sendRequest: editOrganization } = useHttp();
  const { sendRequest: deleteOrganization} = useHttp();
  const { sendRequest: getOrgDetailsById } = useHttp();

  let { allOrganizations, reloadData, reloadUserData } = props;
  const showModal = () => {
    setVisible(true);
    setEditMode(false);
  };
  const handleCancel = (e) => {
    setDeleteVisible(false);
    setVisible(false);
  };

  useEffect(() => {
    setTableData(allOrganizations);
    setFilter(allOrganizations);
  }, [allOrganizations]);

  useEffect(() => {
    let totalPageLength = Math.ceil((filter.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
      setTotalPage(totalPageLength);
  }, [filter]);

  useEffect(() => {
    const result = tableData?.filter((organizationList) => {
      return organizationList.org_name.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
  }, [search]);
  
  let validationSchema = Yup.object().shape({
    organizationName: Yup.string()
    .required("Organization Name is Required")
    .matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
    
    parentOrganizationName:Yup.string()
      .required("Parent Organization is Required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
      level:Yup.string()
      .required("level is Required"),
      childOrganizationName:Yup.string()
      .required("child Organization is Required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
  });

  const handleSubmit = async (values, { resetForm }) => {
    
    setLoading(true);
   
    let data = {
      orgName: values.organizationName,
      orgLevel:values.level,
      orgParent:values.parentOrganizationName,
      orgChildren: values.childOrganizationName,
      email:sessionStorage.getItem("email"),

    };

    if (editMode) {
      data.id = selectedId;
      editOrganization(APIService.editOrganization(data), responseHandlerEdit, errorHandlerEdit)
    } else {
      addNewOrganization(APIService.addNewOrganization(data), responseHandler, errorHandler)
    }
    setAddOrgLoader(false);
  };

  const responseHandlerEdit = (result) => {
    setVisible(false);
    setLoading(false);
    displayToastMessage(result.MSG, "success");
    setSearch("");
    reloadData();
  }

  const errorHandlerEdit = () => {
    setIndicator(false);
    setVisible(false);
    setSearch("");
    displayToastMessage("Something went wrong!", "error");
  }

  const responseHandler = (result) => {
    if (result.MSG === "Organization name already exists.") {
      displayToastMessage(result.MSG, "error");
      setVisible(false);
      setSearch("");
      setIndicator(false);
    } else {
      setVisible(false);
      setLoading(false);
      displayToastMessage(result.MSG, "success");
      setSearch("");
      reloadData();
    }
  }

  const errorHandler = () => {
    setIndicator(false);
    setVisible(false);
    setSearch("");
    displayToastMessage("Something went wrong!", "error");
  }

  const getOrgDetailsByorgId = async (orgId) => {
    getOrgDetailsById(APIService.getOrgDetailsById(orgId), (result) => {
      setOrgDetails(result.MSG[0])
    })
  };

  const getOrgDetails=async(Id)=>{
    const filteredData = allOrganizations.filter(
      (item) => item.org_id == Id
    );
    setOrgDetails(filteredData[0]);
  }

  useEffect(() => {
    const formValuesClone = { ...initialValues };
    // if orgDetails are updated, then update the initial values
    formValuesClone.organizationName = orgDetails?orgDetails.org_name: ""
    formValuesClone.parentOrganizationName= orgDetails?orgDetails.org_parent:""
    formValuesClone.childOrganizationName= orgDetails?orgDetails.org_child:""
    formValuesClone.level= orgDetails?orgDetails.org_level:""
    setInitialValues(formValuesClone);
    }, [orgDetails])

    const responseHandlerDelete = (result) => {
        setSearch("");
        setDeleteVisible(false);
        setIndicator(false);
        setParentOrganizationName("");
        setChildOrganizationName("");
        setOrganizationName("");
        reloadData();
        reloadUserData();
        displayToastMessage(result.MSG, "success");
        setLevel(null);
        reloadData();
    }

    const errorHandlerDelete = () => {
      setIndicator(false);
      setVisible(false);
      setSearch("");
      displayToastMessage("Something went wrong!", "error");
    }

  const handleDelete = async (value) => {
    setIndicator(true);
    let data = {
      id: value,
      email:sessionStorage.getItem("email"),

    };
    deleteOrganization(APIService.deleteOrganization(data), responseHandlerDelete, errorHandlerDelete)
  };

 

  if (indicator) {
    return (
      <div className="a-loading a-primary a-m-10 a-loading-24 spinner-alignment"></div>
    );
  }

  const renderActionCell = (row) => {
    return(
      <>
        <span className="Appkit4-icon icon-edit-fill action-icon pointer" title="Edit Organization" onClick={() => handleEditButton(row)}></span> &nbsp;
        <span className=" Appkit4-icon icon-delete-fill action-icon pointer" title="Delete Organization" onClick={() => handleDeleteButton(row)}></span>
      </>
    )
  }

  const renderLevelCell = (row) => {
    return "Level " + row?.org_level;
  }

  const handleEditButton = (row) => {
    setEditMode(true);
    setVisible(true);
    // getOrgDetailsByorgId(idData[5])
    getOrgDetails(row?.org_id)
    setOrganizationName(row?.org_name);
    setParentOrganizationName(row?.org_parent);
    setChildOrganizationName(row?.org_child);
    setLevel(Number(row?.org_level));
    setSelectedId(row?.org_id);
  }

  const handleDeleteButton = (row) => {
    setDeleteVisible(true);
    setEditMode(true);
    setSelectedId(row?.org_id);
  }

  const sortFuncForOrder1 = (a, b) => {
    const firstOrderId = (a.org_name).charAt(1);
    const secondOrderId = (b.org_name).charAt(1);
    return firstOrderId > secondOrderId ? 1 : -1;;
}

const sortFuncForOrder2 = (a, b) => {
  const firstOrderId = (a.org_name).charAt(1);
  const secondOrderId = (b.org_name).charAt(1);
  return firstOrderId < secondOrderId ? 1 : -1;;
}
  
  return (
    <div className="App">
      <div className="d-flex justify-content-end pe-3 pt-1">
        <span
          className="Appkit4-icon icon-circle-plus-fill add-st pointer"
          title="Add Organization" onClick={showModal}
        ></span>
      </div>
      <div className="col-lg-12 mt-3 pl-1">
            <div className="ap-table-demo menu-tableAlignment-width">
              {tableData.length > 0 ? (
                <Input
                type="text"
                title= "Search Organization"
                value={search}
                className="ap-field-wrapper-tableSearch"
                onChange={(e) => setSearch(e)}
              /> 
              ) : ""}
                <Table originalData={filter} hasTitle currentPage={current} pageSize={10}>
                    <Column field="org_name" sortKey={filter.length > 0 ? "org_name" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2}>Organization</Column>
                    <Column field="org_level" sortKey={filter.length > 0 ? "org_level" : ""} renderCell={renderLevelCell}>Level</Column>
                    <Column field="org_parent" sortKey={filter.length > 0 ? "org_parent" : ""}>Parent Organization</Column>
                    <Column field="org_child" sortKey={filter.length > 0 ? "org_child" : ""}>Child Organization</Column>
                    <Column field="org_id"
                    renderCell={renderActionCell}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
            </div>
      <div>
        <Modal
          className="baseline-modal-showcase"
          visible={visible}
          onCancel={handleCancel}
          title={editMode ? "Edit Organization" : "Add New Organization"}
          bodyStyle={{maxHeight:"280px"}}
          footerStyle={{paddingTop:"8px", marginTop:"-8px"}}
          modalStyle={{width:"49.75rem", maxHeight:"fit-content"}}
        >
          <OrganisationForm 
            InitialValues={initialValues} 
            handleReset={handleCancel}
            handleSubmit={handleSubmit}
            validationSchema={validationSchema}
            loading={loading}
          />
           
          <ModalFooter>
           
          </ModalFooter>
        </Modal>
        <Modal
          className="baseline-modal-showcase"
          visible={deleteVisible}
          onCancel={handleCancel}
          bodyStyle={{maxHeight:"280px"}}
          footerStyle={{paddingTop:"8px", marginTop:"-8px"}}
          modalStyle={{width:"49.75rem", maxHeight:"fit-content"}}
        >
          <div className="modal-title">
            Are you sure you want to delete this entry?
          </div>
          <ModalFooter>
            <button
              type="button"
              className="cancel-button"
              onClick={handleCancel}
            >
              No
              </button>

            <button
              type="submit"
              className="save-button m-l-2"
              onClick={() => handleDelete(selectedId)}
            >
              Yes
              </button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

Organization.propTypes = {
  allOrganizations: PropTypes.any,
  reloadData: PropTypes.any, 
  reloadUserData: PropTypes.any
}
